/**
 * @author       sarah.walloga@zumper.com (Sarah Walloga)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  getLiveEnv.ts
 */

import { IS_SERVER } from './isServer'
import { processEnv } from './processEnv'

export function getLiveEnv(key: string, defaultValue: string): string
export function getLiveEnv(
  key: string,
  defaultValue?: string | undefined
): string | undefined
export function getLiveEnv(
  key: string,
  defaultValue?: string | undefined
): string | undefined {
  if (IS_SERVER) {
    return processEnv[key] ?? defaultValue
  }
  return (
    document
      ?.querySelector?.(`meta[name="zumper:${key.toLowerCase()}"]`)
      ?.getAttribute?.('content') ??
    defaultValue ??
    // fall back to whatever was baked in (in case it's not been made available as a meta tag)
    process?.env?.[key]
  )
}
